import { gql } from '@apollo/client';
import React from 'react';
import { SwiperOptions } from 'swiper';
import { RestrictPlatform } from '../RestrictPlatform';
import { PumoModuleSlide, PUMO_MODULE_SLIDE_FRAGMENT } from '../PumoModuleSlide';
import { EditorialBgColor, EDITORIAL_BG_COLORS } from '../PumoModuleEditorialText';
import { SinglePumoModuleFragment } from '../../generated/types/SinglePumoModuleFragment';
import { SwiperCarousel } from '../SwiperCarousel';
import './SinglePumoModule.scss';

export interface Props {
  singlePumoModule: SinglePumoModuleFragment;
  beforeEyebrow?: React.ReactNode;
  afterEyebrow?: React.ReactNode;
  normalizePumoStyles?: boolean;
}

const SWIPER_SINGLE_MODULE_CONFIG: SwiperOptions = {
  speed: 1400,
  slidesPerView: 1,
  slidesPerGroup: 1,
  loop: true,
  loopFillGroupWithBlank: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false
  }
};

export const SINGLE_PUMO_MODULE_FRAGMENT = gql`
  fragment SinglePumoModuleFragment on SinglePumoModule {
    id
    bgColor
    platforms: platform
    slides {
      ...PumoModuleSlideFragment
    }
    modelId
    moduleType
  }
  ${PUMO_MODULE_SLIDE_FRAGMENT}
`;

export const SinglePumoModule: React.FC<Props> = ({
  singlePumoModule: { slides, platforms, bgColor, modelId, moduleType },
  beforeEyebrow,
  afterEyebrow,
  normalizePumoStyles
}) => {
  if (slides.length === 0) return null;

  const backgroundColor = EDITORIAL_BG_COLORS[bgColor as EditorialBgColor];

  return (
    <RestrictPlatform platforms={platforms}>
      <div
        className="SinglePumoModule"
        style={{ backgroundColor }}
        data-model-id={modelId}
        data-module-type={moduleType}
      >
        {slides.length > 1 ? (
          <SwiperCarousel
            defaultConfig={SWIPER_SINGLE_MODULE_CONFIG}
            className="SinglePumoModule__carousel"
            classNameContainer="SinglePumoModule__container"
            classNameNavigation="SinglePumoModule__nav-buttons"
          >
            {slides.map((slide, index) => (
              <PumoModuleSlide
                key={index}
                slide={slide}
                beforeEyebrow={beforeEyebrow}
                afterEyebrow={afterEyebrow}
                normalizePumoStyles={normalizePumoStyles}
              />
            ))}
          </SwiperCarousel>
        ) : (
          <PumoModuleSlide
            slide={slides[0]}
            beforeEyebrow={beforeEyebrow}
            afterEyebrow={afterEyebrow}
            normalizePumoStyles={normalizePumoStyles}
          />
        )}
      </div>
    </RestrictPlatform>
  );
};
